import { initDOMObserver } from "@repo/prototype-shell-sdk/dom";
import { META_ROOT_ID } from "@repo/prototype-shell-sdk/constants";
import { mountMetaLayer } from "@repo/prototype-shell-sdk/meta";
import { connect } from "@repo/prototype-shell-sdk/rpc";
import {
  createCoreChannel,
  createDebugChannel,
  createThemeChannel,
} from "@repo/prototype-shell-sdk/rpc/channels";
import { createContext, StrictMode, useContext, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { ShellApp } from "./app";
import { ShellPortalProvider } from "./portal-context";
import shellCss from "./styles/shell.css?inline";

const metaRoot = document.getElementById(META_ROOT_ID);
if (!metaRoot) {
  throw new Error("[prototype-shell-client] #$$meta-root not found");
}

const shadowRoot = mountMetaLayer(document);
const shellSheet = new CSSStyleSheet();
shellSheet.replaceSync(shellCss);
shadowRoot.adoptedStyleSheets = [...shadowRoot.adoptedStyleSheets, shellSheet];

const container = document.createElement("div");
shadowRoot.appendChild(container);

const { destroyAll, channels } = await connect(window.parent, [
  createCoreChannel("remote"),
  createDebugChannel("remote"),
  createThemeChannel("remote"),
]);

const teardownDOMObserver = initDOMObserver(document);

window.addEventListener("beforeunload", () => {
  destroyAll();
  teardownDOMObserver();
});

const RpcChannelContext = createContext<typeof channels>(channels);
function RpcChannelsProvider({ children }: { children: ReactNode }) {
  return (
    <RpcChannelContext.Provider value={channels}>
      {children}
    </RpcChannelContext.Provider>
  );
}

export function useRpcChannels() {
  return useContext(RpcChannelContext);
}

createRoot(container).render(
  <StrictMode>
    <RpcChannelsProvider>
      <ShellPortalProvider container={container}>
        <ShellApp />
      </ShellPortalProvider>
    </RpcChannelsProvider>
  </StrictMode>
);
